import React from 'react'

import AdapterLink from '../../@react-fefmwk/links/modules/AdapterLink'
import FieldEntityView from '../../@react-fefmwk/entity/modules/FieldEntityView'
import Button from '@material-ui/core/Button'
import PersonIcon from '@material-ui/icons/Person'

class FieldIdPeople extends React.Component {
    render() {
        const id_people = this.props.id_people
        const title = this.props.title ? this.props.title : "Scheda persona"
        const tooltipText = this.props.tooltipText ? this.props.tooltipText : "Scheda persona"
        const tooltipPlacement = this.props.tooltipPlacement ? this.props.tooltipPlacement : "right"
        return  !id_people || id_people <= 0 || id_people === '-'
            ? null
            : <FieldEntityView title={title} icon={PersonIcon}
                id_entity={id_people} entity="people"
                fields={[]}
                actions={<React.Fragment>
                    <Button variant="contained" size="small" color="primary"
                        component={AdapterLink} to={'/people/card/'+id_people} target="_blank"
                    >Visualizza</Button>
                </React.Fragment>}
                tooltipText={tooltipText}
                tooltipPlacement={tooltipPlacement}
            />
    }
}

export default FieldIdPeople